import store from '@/store'
import {onUpdateFriend, onDeleteFriend} from './friends'
import {onRevocateMsg} from './msgs'

export function onSysMsgs (sysMsgs) {
  store.commit('nim/updateSysMsgs', sysMsgs)
}

export function onSysMsg (sysMsg) {
  switch (sysMsg.type) {
    // 在其他端添加或删除好友
    case 'addFriend':
      onUpdateFriend(null, {
        account: sysMsg.from
      })
      store.commit('nim/updateSysMsgs', [sysMsg])
      break
    case 'deleteFriend':
      onDeleteFriend(null, {
        account: sysMsg.from
      })
      break
    // 对方消息撤回
    case 'deleteMsg':
      if(sysMsg.scene === 'p2p') {
        sysMsg.sessionId = `p2p-${sysMsg.from}`
      } else {
        sysMsg.sessionId = `team-${sysMsg.to}`
      }
      onRevocateMsg(null, sysMsg)
      break
    case 'teamInvite': //被邀请入群
    case 'applyTeam':  // 申请入群
    case 'rejectTeamApply':  // 申请入群被拒绝
    case 'rejectTeamInvite': // 拒绝入群邀请
      store.commit('nim/updateSysMsgs', [sysMsg])
      break
  }
  store.commit('nim/updateSysMsgState', sysMsg)
}

export function onSysMsgUnread (obj) {
  store.commit('nim/updateSysMsgUnread', obj)
}

export function onCustomSysMsgs (customSysMsgs) {
  if (!Array.isArray(customSysMsgs)) {
    console.log('onCustomSysMsgs=>>>',customSysMsgs)
    //系统消息
    let customContent = JSON.parse(customSysMsgs.content);
    // 列表中添加一个联系人。并且非投递来的用户
    if(customContent.message_type === 3001 && customContent.data.status !==2){
      let chatUserList = JSON.parse(JSON.stringify(store.state.im.chatUserList))
      let c_token = customContent.data.c_token;
      //如果联系人列表中不存在当前用户，再插入到当前联系人列表中
      if(!chatUserList[c_token]){
        //整理数据
        if(!customContent.data.last_message){
          customContent.data.sort_time = new Date().getTime()
          customContent.data.last_message = {content:{}}
        }
        chatUserList.unshift(customContent.data);
        store.commit('im/updateChatUserList', chatUserList);
        
        // 增加新用户的未读数
        // unreadMessage[c_token] = 1;
        // store.commit('im/updateUnreadMessage', unreadMessage);
      }
    }
  }
  /* if (!Array.isArray(customSysMsgs)) {
    customSysMsgs = [customSysMsgs]
  }
  customSysMsgs = customSysMsgs.filter(msg => {
    if (msg.type === 'custom') {
      if (msg.content) {
        try {
          let content = JSON.parse(msg.content)
          // 消息正在输入中
          if ((content.id + '') === '1') {
            return false
          }
        } catch (e) {}
      }
    }
    return true
  })
  if (customSysMsgs.length > 0) {
    store.commit('nim/updateCustomSysMsgs', customSysMsgs)
  }*/
}

// 不传obj则全部重置
export function markSysMsgRead ({state, commit}, obj) {
  const nim = state.nim
  let sysMsgs = []
  if (obj && obj.sysMsgs) {
    sysMsgs = obj.sysMsgs
  } else {
    sysMsgs = state.sysMsgs
  }
  if (Array.isArray(sysMsgs) && sysMsgs.length > 0) {
    nim.markSysMsgRead({
      sysMsgs,
      done: function (error, obj) {
      }
    })
  }
}

export function markCustomSysMsgRead ({state, commit}) {
  commit('updateCustomSysMsgUnread', {
    type: 'reset'
  })
}

export function resetSysMsgs ({state, commit}, obj) {
  commit('resetSysMsgs', obj)
}

export function deleteSysMsgs({commit}, obj) {
  commit('deleteSysMsgs', obj)
}